import { ChangeDetectionStrategy, Component, OnInit, TemplateRef } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentSagService } from 'src/app/projekter/services/current-sag/current-sag.service';
import { DynamicFieldComponent } from '../../models/dynamic-field-component';
import { DynamicFormEntry } from '../../models/dynamic-form-entry';

@Component({
  selector: 'bom-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormInputComponent implements DynamicFieldComponent, OnInit {
  config: DynamicFormEntry;
  group: FormGroup;
  isDisabled$: Observable<boolean>;
  showHentFraMinProfilButton: boolean;
  hentFraMinProfilButton: TemplateRef<any>;

  get groupControl(): AbstractControl {
    return this.group.controls[this.config.name];
  }

  constructor(private currentSagService: CurrentSagService, private route: ActivatedRoute) {}
  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.isDisabled$ = this.currentSagService.isFaseDisabled(id);
    });
  }
  groupControlForCell(id: string): AbstractControl {
    const groupControl = this.group.controls[this.config.name].get(id).get('K3');
    if (groupControl === null) {
      return this.group.controls[this.config.name];
    }
    return groupControl;
  }
}
